import { render } from "./Bots__stopped.vue?vue&type=template&id=a1c7eaec"
import script from "./Bots__stopped.vue?vue&type=script&lang=js"
export * from "./Bots__stopped.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__